import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "disabled", "fullWidth", "inputProps", "invalid", "name", "onChange", "labelProps", "options", "required", "subText", "subTextProps", "tabIndex", "textProps", "theme", "tooltip", "tooltipProps", "value"],
    _excluded2 = ["value", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames/bind';
import { ErrorCircleFilled } from "../icons";
import { FieldRoot } from "../internal/Field";
import { RadioBase } from "../internal/RadioBase";
import { TextBase } from "../internal/TextBase";
import styles from './SelectGender.css';
var cx = classNames.bind(styles);
var defaultOptions = [{
  label: 'Мужчина',
  value: 'MALE'
}, {
  label: 'Женщина',
  value: 'FEMALE'
}];
export var SelectGender = function SelectGender(_ref) {
  var _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      inputProps = _ref.inputProps,
      invalid = _ref.invalid,
      name = _ref.name,
      onChange = _ref.onChange,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? defaultOptions : _ref$options,
      required = _ref.required,
      subText = _ref.subText,
      subTextProps = _ref.subTextProps,
      tabIndex = _ref.tabIndex,
      textProps = _ref.textProps,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'b2c' : _ref$theme,
      tooltip = _ref.tooltip,
      _ref$tooltipProps = _ref.tooltipProps,
      tooltipProps = _ref$tooltipProps === void 0 ? {} : _ref$tooltipProps,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(FieldRoot, _extends({}, rest, {
    tooltip: tooltip,
    invalid: invalid,
    tooltipProps: tooltipProps,
    subText: subText,
    subTextProps: _objectSpread({
      errorIcon: /*#__PURE__*/React.createElement(ErrorCircleFilled, {
        size: "md"
      })
    }, subTextProps),
    classes: {
      root: cx('root', classes.root, {
        fullWidth: fullWidth
      }),
      container: cx('container', classes.container)
    }
  }), options.map(function (_ref2) {
    var optionValue = _ref2.value,
        label = _ref2.label,
        restOptions = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/React.createElement("label", _extends({}, labelProps, {
      key: optionValue,
      className: cx('label', {
        invalid: invalid,
        disabled: disabled
      }, classes.label)
    }, restOptions), /*#__PURE__*/React.createElement(RadioBase, _extends({
      checked: optionValue === value,
      className: classes.input,
      disabled: disabled,
      name: name,
      onChange: onChange,
      required: required,
      tabIndex: tabIndex,
      theme: theme,
      value: optionValue
    }, inputProps)), /*#__PURE__*/React.createElement(TextBase, _extends({}, textProps, {
      indent: true,
      classes: {
        root: cx('text-component', classes.text)
      },
      as: "span"
    }), label));
  }));
};
export default SelectGender;